import { useState } from "react";
import { ChevronDown } from "lucide-react";

export const CollapsibleBlock = ({ title, testid, children }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="space-y-2">
      <button type="button" onClick={() => setOpen(!open)} data-testid={`${testid}-toggle`}
        className="w-full flex items-center justify-between bg-white rounded-xl border px-4 py-3 font-bold hover:bg-slate-50">
        <span>{title}</span>
        <ChevronDown className={`w-5 h-5 transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && children}
    </div>
  );
};
